import {Injectable, Injector} from '@angular/core';
import {WindowService} from './window.service';
import {TranslateService} from '@ngx-translate/core';
import {LangList} from '../shareModel';
import {Store} from '@ngrx/store';
import * as fromStore from './../store';
import {LOCATION_INITIALIZED} from '@angular/common';
import {Observable, of} from 'rxjs';

export const STORE_KEY = 'userLanguage';

@Injectable()
export class LanguageService {
  lang = 'en'; // Default English
  langListVal = [];
  private initialized = false;
  
  // 💡 使用 Injector 延遲獲取 TranslateService，避免構造時的 DI 順序問題
  private get translateService(): TranslateService {
    return this.injector.get(TranslateService);
  }
  
  constructor(private injector: Injector, private store: Store<fromStore.State>) {
    this.langListVal = LangList.map((i) => i.value);
    // 💡 不在構造函數中執行任何初始化，完全由外部控制
  }
  
  // 💡 公開方法，在應用啟動後安全調用
  initializeTranslation(): void {
    if (this.initialized) {
      return;
    }
    
    try {
      this.translateService.addLangs(this.langListVal);
      // Reset the Event Language Translate.
      this.translateService.onLangChange.subscribe((res) => {
        this.store.dispatch(new fromStore.ChangeLanguageEventMaps());
        this.store.dispatch(new fromStore.ChangeLanguageFaultCodes());
      });
      this.initialized = true;
    } catch (error) {
      console.error('Failed to initialize LanguageService:', error);
    }
  }

  set setLanguage(value) {
    localStorage.setItem(STORE_KEY, String(value));
  }
  get getLanguage() {
    return localStorage.getItem(STORE_KEY);
  }

  init(): any { // move to app.module to execute.
    let storeLang = this.getLanguage;
    if (!storeLang || !this.includeLanguage(storeLang)) {
      storeLang = this.lang;
    }
    this.translateService.setDefaultLang(storeLang);
    this.translateService.use(storeLang);
  }

  initDefaultLanguage() {
    this.translateService.use(this.lang);
    this.translateService.setDefaultLang(this.lang);
  }

  changeLanguage(lang) {
    if (this.includeLanguage(lang)) {
      this.setLanguage = lang;
      this.translateService.use(lang);
    } else {
      this.initDefaultLanguage();
    }
  }

  includeLanguage(language) {
    return this.langListVal.includes(language);
  }

}
